



















import {Vue, Component, Watch} from 'vue-property-decorator'
import Container from '../components/proxy/Container.vue'
import CloseButton from '../components/CloseButton.vue'
import {Action, State} from 'vuex-class'
import {ProfileState} from '@/store/modules/profile'
import {WalletState} from '@/store/modules/wallet'
import Divider from '../components/proxy/Divider.vue'
import Btn from '../components/proxy/Btn.vue'
import TopBar from '@/components/TopBar.vue'
import Tabs from '../components/proxy/Tabs/Tabs.vue'
import TabItems from '../components/proxy/Tabs/TabItems.vue'
import Tab from '../components/proxy/Tabs/Tab.vue'
import TabItem from '../components/proxy/Tabs/TabItem.vue'
import Button from '../components/Button.vue'
import Icon from '../components/proxy/Icon.vue'
import collect from 'collect.js'
import {PopupState} from '@/store'
import TabHistoryMixin from '../lib/TabHistory'

import Overview from '../components/wallet/Overview.vue'
import PaymentMethods from '../components/wallet/PaymentMethods.vue'
import Invoices from '@/components/wallet/Invoices.vue'
import Deposits from '@/components/wallet/Deposits.vue'
import AddCard from './AddCard.vue'
import IsLogged from '@/components/IsLogged.vue'
import Layout from '@/components/proxy/Layout.vue'
import AddCoupon from '@/components/wallet/AddCoupon.vue'
import {AppConfigState} from '@/store/modules/configuration'
import BuyTopUp from '@/views/BuyTopUp.vue'
import PaymentMethodsWithValidation from '@/components/fields/PaymentMethodsWithValidation.vue'

@Component({
  components: {
    PaymentMethodsWithValidation,
    BuyTopUp,
    AddCoupon,
    Layout,
    IsLogged,
    AddCard,
    Overview,
    PaymentMethods,
    Invoices,
    Deposits,
    Icon,
    Button,
    TabItem,
    Tab,
    TabItems,
    Tabs,
    TopBar,
    Container,
    Divider,
    Btn,
    CloseButton,
  },
  name: 'Wallet',
  mixins: [TabHistoryMixin],
})

export default class Wallet extends Vue {
  @State('profile') public profileState!: ProfileState
  @State('wallet') public walletState!: WalletState
  @State('configuration') public configuration!: AppConfigState

  @Action('openDialog') public openDialog: any
  @Action('getPaymentMethods') public getPaymentMethods: any
  @Action('getClient') public getClient: any
  @Action('setActionButtons') public setActionButtons: any
  @Action('openPopup') public openPopup: any
  @Action('getWallets') public getWallets: any

  public currentTab: number | null = null
  public tabMap: { [key: string]: number } = {
    '#': 0,
    '#invoices': 1,
    '#deposits': 2,
  }

  protected get defaultWallet() {
    if (this.walletState.wallets) {
      return collect(this.walletState.wallets).firstWhere('default', true)
    }
    return false
  }

  protected get sortedWallets() {
    if (this.walletState.wallets) {
      return collect(this.walletState.wallets).sortByDesc('default').all()
    }
  }

  public mounted() {
    this.getWallets()
    if (!this.profileState.client) {
      this.getClient()
    }
    if (this.walletState.paymentMethods === null) {
      this.getPaymentMethods()
    }
  }

  protected addCard() {
    this.openPopup(new PopupState(AddCard, {}, this.$t('profile.wallet.addCard.title')))
  }
}
